import { reportMachineRouteSelection, type MachineRouteReport } from "@/transport/fleet"

let clientID: string | undefined
export const routeClientID = () => clientID ??= crypto.randomUUID()

let sequence = 0
export function stampRouteReport(report: MachineRouteReport): MachineRouteReport {
  return { ...report, client_id: routeClientID(), client_sequence: ++sequence,
    client_time_ms: Date.now(), client_elapsed_ms: Math.floor(performance.now()),
    visibility: typeof document === "undefined" ? "unknown" : document.visibilityState,
    online: typeof navigator === "undefined" ? undefined : navigator.onLine,
  }
}

export function reportRouteEvent(report: MachineRouteReport) {
  // Diagnostics never block transport installation or request recovery.
  try {
    void Promise.resolve(reportMachineRouteSelection(stampRouteReport(report))).catch(() => {})
  } catch {
    // A synchronous transport failure is also non-fatal.
  }
}
